import { WriteTransaction } from 'replicache'
import { userPreferencesMutators } from '.'
import { invariant } from '@epic-web/invariant'

/* -------------------------------------------------------------------------------------------------
 * Make Blocks Favorite
 * -----------------------------------------------------------------------------------------------*/

export async function makeBlocksFavorite(
  tx: WriteTransaction,
  { blockIds, userId }: { blockIds: string[]; userId: string }
) {
  const currentUserPreferences =
    await userPreferencesMutators._getUserPreferences(tx, userId)
  invariant(currentUserPreferences, `userPreferences not found for ${userId}`)

  // add new blockIds to current ones via set to prevent duplicates
  const newFavoriteBlocks = new Set(currentUserPreferences.favoriteBlocks)
  blockIds.forEach((bId) => newFavoriteBlocks.add(bId))

  // update userPreferences
  await userPreferencesMutators._updateUserPreferences(tx, {
    id: userId,
    favoriteBlocks: Array.from(newFavoriteBlocks),
  })
}

/* -------------------------------------------------------------------------------------------------
 * Make Blocks Un Favorite
 * -----------------------------------------------------------------------------------------------*/

export async function makeBlocksUnFavorite(
  tx: WriteTransaction,
  { blockIds, userId }: { blockIds: string[]; userId: string }
) {
  const currentUserPreferences =
    await userPreferencesMutators._getUserPreferences(tx, userId)
  invariant(currentUserPreferences, `userPreferences not found for ${userId}`)

  // remove blockIds from current ones via set to prevent duplicates
  const newFavoriteBlocks = new Set(currentUserPreferences.favoriteBlocks)
  blockIds.forEach((bId) => newFavoriteBlocks.delete(bId))

  // update userPreferences
  await userPreferencesMutators._updateUserPreferences(tx, {
    id: userId,
    favoriteBlocks: Array.from(newFavoriteBlocks),
  })
}
